import React, {useEffect, useContext} from "react";
import LoaderAnim from "../../components/LoaderAnim/index";
import {useDataApi, API} from "../../components/API/index";
import Context, {Actions} from "../../reducers/Context";
import NavButton from "../../components/NavButton";

const TeamSelect = props => {
    const {dispatch, state} = useContext(Context);
    const {data, isLoading, isError, doFetch} = useDataApi("");

    const didSelectTeam = team => {
        dispatch({
            type: Actions.SELECTED_TEAM,
            payload: {team}
        });
        if (!state.loggedIn) {
            doFetch(API.CREATE_SESSION, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({auth: state.auth, team})
            });
        } else {
            dispatch({
                type: Actions.SELECTED_LOGGED_IN_TEAM
            });
        }
    };

    useEffect(() => {
        if (data) {
            //console.log("got data", data);
            dispatch({
                type: Actions.RECEIVED_SESSION_DATA,
                payload: data
            });
        }
    }, [data]);

    return (
        <>
            {(state.loginTeams && state.loginTeams.length > 1 && <div className="afs-msm-stage-content">
                {isError && <div>Something went wrong ...</div>}

                {isLoading ? (
                    <LoaderAnim/>
                ) : (
                    <ul>
                        {state.loginTeams &&
                        state.loginTeams.map(team => {
                            return (
                                <TSLoginTeam
                                    selected={() => {
                                        didSelectTeam(team);
                                    }}
                                    key={team.TeamMemberID}
                                    {...team}
                                />
                            );
                        })}
                    </ul>
                )}
            </div>
            )}
            {!state.loggedIn && (
                <div className="afs-msm-stage-action-buttons">
                    <NavButton
                        text="BACK"
                        actionType={Actions.TO_STAGE}
                        payload={{toStage: "login-method"}}
                    />
                </div>
            )}
        </>
    );
};

const TSLoginTeam = props => {
    return (
        <li onClick={props.selected} className="afs-msm-login-team add-all-padding">
            <img
                className="afs-msm-login-team-badge"
                src={props.TeamSiteTeamBadgeUrl}
                alt="team-badge"
            />
            <div>
                <b className="afs-msm-login-team-name">{props.TeamSiteDisplayName}</b>
                <div className="afs-msm-login-team-user-full-name">
                    {props.UserFullName}
                </div>
                <div className="afs-msm-login-team-user-username">
                    {props.UserUsername}
                </div>
            </div>
        </li>
    );
};

export default {
    id: "team-select",
    title: "Select your team",
    subtitles: [""],
    imageUrl:
        "https://www.teamstats.net/teamstats-media/images/signup-form/squad-blurred.jpg",
    component: TeamSelect
};
